module.exports = __webpack_public_path__ + "b1b9671a6886e9f039226ea3c2b5215f.png";